import { Row, TabContent, TabPane } from "reactstrap";
import { SocialAppTabContentProp } from "../../../Type/SocialAppType";
import AboutTab from "./AboutTab";
import TimelineTab from "./TimeLineTab";
import AllCards from "./AllCards";
import PhotosTab from "./PhotosTab";

const SocialAppTabContent = ({ activeTab }: SocialAppTabContentProp) => {
  return (
    <TabContent activeTab={activeTab} className="tab-content">
      <TabPane tabId={1}>
        <TimelineTab />
      </TabPane>
      <TabPane tabId={2}>
        <AboutTab />
      </TabPane>
      <TabPane tabId={3}>
        <Row>
          <AllCards />
        </Row>
      </TabPane>
      <TabPane tabId={4}>
        <Row>
          <PhotosTab />
        </Row>
      </TabPane>
    </TabContent>
  );
};

export default SocialAppTabContent;
